import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export default class Keyfigures{
    
    constructor(element) {
        this._wrapper = element;
        this._rowTitle = this._wrapper.querySelector('.js-keyfigures-row-title');
        this._container = this._wrapper.querySelector('.js-keyfigures-container');
        this._items = this._wrapper.querySelectorAll('.js-keyfigures-item');
        this._last = this._wrapper.querySelectorAll('.js-keyfigures-last');
        this._lastTitle = this._wrapper.querySelectorAll('.js-keyfigures-last-title');
        this._lastShape = this._wrapper.querySelectorAll('.js-keyfigures-last-shape');
        this._lastLeftImg = this._wrapper.querySelectorAll('.js-keyfigures-last-img-left');
        this._lastLeftMask = this._wrapper.querySelectorAll('.js-keyfigures-last-mask-left');
        this._lastRightImg = this._wrapper.querySelectorAll('.js-keyfigures-last-img-right');
        this._lastRightMask = this._wrapper.querySelectorAll('.js-keyfigures-last-mask-right');
        if(window.initAnims){
            this.initAnims();
        }
    }

    initAnims(){
        gsap.from(this._rowTitle, {y:100, alpha:0, ease:"power2.out", duration:1, scrollTrigger:{
                trigger:this._container,
                start:"top bottom-=250", 
                scrub:false,
                markers:false
            }
        });
        
        
        app.nodesEach(this._items, (el) => {
            let _mask = el.querySelector('.js-keyfigures-item-mask');
            let _img = el.querySelector('.js-keyfigures-item-img');
            let _text = el.querySelector('.js-keyfigures-item-text');
            let _btns = el.querySelectorAll('.js-keyfigures-item-btn');
            
            let timeline = gsap.timeline({
                scrollTrigger:{
                    trigger:el,
                    start:() => {
                        if(window.matchMedia('(min-width:1200px').matches){
                            return "top center";
                        }
                        else{
                            return "top bottom -= 100";
                        }
                    },
                    scrub:false,
                    markers:false
                    
                }
            });
            
            timeline.to(_mask, {y:'100%', duration:1.5, ease:'power2.out'}, 'start');
            timeline.from(_img, {scale:1.5, duration:1.5, ease:'power2.out'}, 'start');
            timeline.from(_text, {y:100, alpha:0, ease:'power2.out', duration:1.5}, 'start');
            timeline.from(_btns, {y:100, alpha:0, ease:'power2.out', stagger:0.2, duration:1.5}, 'start+=0.2');
            
        });
        
        
        let lastTimeline = gsap.timeline({
            scrollTrigger:{
                trigger:this._last,
                start:() => {
                    if(window.matchMedia('(min-width:1200px').matches){
                        return "top center";
                    }
                    else{
                        return "top bottom -= 100";
                    }
                },
                scrub:false,
                markers:false

            }
        })
        
        lastTimeline.from(this._lastTitle, {y:100, alpha:0, ease:"power2.out", duration:1}, 0);
        lastTimeline.from(this._lastShape, {alpha:0, ease:"power2.out", duration:0.5}, 0.2);
        
        lastTimeline.to(this._lastLeftMask, {y:'100%', duration:1, ease:'power2.out'}, 0.6);
        lastTimeline.from(this._lastLeftImg, {scale:1.5, duration:1, ease:'power2.out'}, 0.6);

        //
        lastTimeline.to(this._lastRightMask, {y:'100%', duration:1, ease:'power2.out'}, 1.2);
        lastTimeline.from(this._lastRightImg, {scale:1.5, duration:1, ease:'power2.out'}, 1.2);
        
    }
    
}